'use client'

import { cn } from "@/lib/utils/utils"
import { useMounted } from "@/lib/utils/utils-client"
import { useEffect, useState } from "react"
import { MdKeyboardArrowDown } from "react-icons/md"
import { LangCode, useI18nValue } from "../i18n/lang-context"
import { Glossary } from "../jbda/glossary"
import GlossaryCopyLink from "../jbda/glossary-copy-link"
import MD from "../markdown"
import { Flex, FlexCol } from "../ui/flex"


export function Entries({glossary, background2, langCode}: {glossary: Glossary, background2?: boolean, langCode: LangCode}) {
  
    useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
  
    const entry = document.querySelector(hash);
  
    if (entry) {
      // Attendre que l’animation finisse
      setTimeout(() => {
        entry.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, []);

  return Object.keys(glossary).map((key: string) => {
    return <Entry key={key} _key={key} glossary={glossary} background2={background2} langCode={langCode} />
  })
}

export function Entry({glossary, _key, background2, langCode}: {glossary: Glossary, _key: string, background2?: boolean, langCode: LangCode}) {
  const i18nValue = useI18nValue()

  const [opened, setOpened] = useState<boolean>(true)

  const mounted = useMounted()
  useEffect(() => {
    if(!mounted || typeof window === 'undefined') return 
    // Access the anchor using window.location.hash
    const anchor = window.location.hash
    // If access to a direct Glossary Entry is requested, it will be unfolded
    if (anchor === '#' + _key)
      setOpened(true)
    else
      setOpened(false)
  }, [mounted])

  const entry = glossary[_key]
  return (
    <FlexCol id={_key} key={_key} className='scroll-mt-24 w-full items-start gap-2 sm:gap-3 mb-3 sm:mb-4'>
      <Flex className={cn('w-full cursor-pointer flex-nowrap items-center justify-between gap-2 sm:gap-3 p-2 sm:p-3 rounded-md hover:opacity-100',
                          opened ? (background2 ? 'bg-background' : 'bg-background2') : 'opacity-80',
                          background2 ? 'hover:bg-background' : 'hover:bg-background2')}
            onClick={() => setOpened(!opened)}>
        <Flex>
          <h3 className='text-lg font-semibold pr-1'>{i18nValue(entry.name, langCode)}</h3>
          <GlossaryCopyLink _key={_key} langCode={langCode} />
        </Flex>
        <div id={'ARROW_' + _key} className='text-lg font-semibold opacity-70'>
          <MdKeyboardArrowDown size={24} className={cn('transition-all', opened ? 'rotate-180' : '')} />
        </div>
      </Flex>
      <MD className={cn('p-2 sm:p-3 px-3 sm:px-4 rounded-lg', opened ? '' : 'hidden', background2 ? 'bg-background' : 'bg-background2')}
          glossary={glossary}
          langCode={langCode}>
        {i18nValue(entry.longDesc, langCode)}
      </MD>
    </FlexCol>
  )
}